import { render } from "./receiptGoods.vue?vue&type=template&id=d6379682&scoped=true"
import script from "./receiptGoods.vue?vue&type=script&lang=js"
export * from "./receiptGoods.vue?vue&type=script&lang=js"

import "./receiptGoods.vue?vue&type=style&index=0&id=d6379682&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6379682"]])

export default __exports__